import { c as _c } from "react/compiler-runtime";
import type { KeyedAttachments } from '@/components/Pages/Insights/useInsightExecSumActions';
import { EventSessionTemplate } from '@/components/Templates/Events/EventSessionTemplate';
import useTranslation from '@/hooks/useTranslation';
import type { IContentItem, IEventSession, IEventWebinar, IRole } from '@/interfaces';
import type { ShareAction } from 'bnef';
interface IWebinarPageProps {
  event: IEventWebinar;
  session: IEventSession;
  attachments?: KeyedAttachments;
  people?: IRole[];
  related?: IContentItem[];
  shareToken?: null | ShareAction;
}
export const WebinarPage = props => {
  const $ = _c(5);
  const {
    t
  } = useTranslation("events");
  let t0;
  if ($[0] !== t) {
    t0 = t("More.from_webinar");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== t0) {
    t1 = <EventSessionTemplate {...props} moreTitle={t0} />;
    $[2] = props;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};